import React from 'react'
import { Text } from '@usap/uicomponents'
import Heading from './Heading'

const headingTypes = {
  h1: 1, h2: 2, h3: 3, h4: 4, h5: 5, h6: 6,
}
const Title = ({
  type = 'text',
  label,
  color = 'dark-2',
  ...props
}) => {
  const { [type]: level } = headingTypes
  if (level) {
    return (
      <Heading
        level={level}
        title={label}
        {...(color === 'default' ? {} : { color })}
        {...props}
      />
    )
  }
  return (
    <Text
      size="small"
      weight="normal"
      {...(color === 'default' ? {} : { color })}
      {...props}
    >
      {label}
    </Text>
  )
}

export default Title
